export enum Cookies {
  GTM_CAMPAIGN = '__gtm_campaign_url',
  GTM_REFERRER = '__gtm_referrer',
  COOKIE_INFORMATION_MARKETING_CONSENT = 'cookie_cat_marketing',
  FACEBOOK_PIXEL = '_fbp',
  FACEBOOK_CLICK_ID = '_fbc',
}
